/**
 * PATH: packages/email-hub/src/feature/components/email-context/SyncedFromDetails.tsx
 * FILE_ID: EMAILHUB-EMAILCONTEXT-SYNCEDFROM-001
 * PURPOSE: Render the mailbox-of-origin identity for one email.
 * WHY: Lifted out of EmailJobContextRail's first section so the tablet-width
 *      header chip can open the SAME block instead of a summary of it. One
 *      renderer, two containers.
 * FLOW:
 * ┌────────────────┐   ┌──────────────┐   ┌──────────────────────┐
 * │ SyncedMailbox   │ → │ badge + name │ → │ "<owner>'s mailbox"   │
 * └────────────────┘   └──────────────┘   └──────────────────────┘
 * RELATED:
 * - ./emailContextFormat.ts: resolveSyncedMailbox produces the input.
 */
import type { SyncedMailbox } from './emailContextFormat'

export interface SyncedFromDetailsProps {
  mailbox: SyncedMailbox
}

export function SyncedFromDetails({ mailbox }: SyncedFromDetailsProps) {
  return (
    <div className="flex items-center gap-2.5" data-testid="synced-from-details">
      <div
        className="h-9 w-9 shrink-0 rounded-full border border-border/60 bg-secondary flex items-center justify-center text-xs font-semibold text-secondary-foreground"
        aria-hidden
      >
        {mailbox.initials}
      </div>
      <div className="min-w-0">
        <p
          className="truncate text-sm font-medium text-foreground"
          title={mailbox.label}
        >
          {mailbox.label}&apos;s mailbox
        </p>
        {mailbox.address && (
          <p
            className="truncate text-[11px] text-muted-foreground"
            title={mailbox.address}
          >
            {mailbox.address}
          </p>
        )}
      </div>
    </div>
  )
}
